import React from 'react';

import { Chip, Stack, Typography } from '@mui/material';

import ScheduleStatusChip from '../ScheduleStatusChip';

interface Props {
  emailStatus: string;
  subjectLine: string;
  heroOfferIds: Array<string>;
  offerId: string;
  footer: React.ReactNode;
}

function HeroPlannerDebugEmailSummary({ emailStatus, subjectLine, heroOfferIds, offerId, footer }: Props) {
  const needle = offerId.trim();

  return (
    <Stack gap={0.75}>
      <Stack direction="row" gap={1} alignItems="center" flexWrap="wrap">
        <ScheduleStatusChip status={emailStatus} />
        <Typography variant="body2" noWrap title={subjectLine} sx={{ maxWidth: 320 }}>
          {subjectLine}
        </Typography>
      </Stack>
      <Stack direction="row" gap={0.5} alignItems="center" flexWrap="wrap">
        <Typography variant="caption" color="text.secondary" mr={0.5}>
          Hero
        </Typography>
        {heroOfferIds.map((heroOfferId) => (
          <Chip
            key={heroOfferId}
            size="small"
            label={heroOfferId}
            color={heroOfferId === needle ? 'info' : 'default'}
            variant={heroOfferId === needle ? 'filled' : 'outlined'}
            sx={{ fontFamily: 'monospace' }}
          />
        ))}
        {footer}
      </Stack>
    </Stack>
  );
}

export default HeroPlannerDebugEmailSummary;
